import { render, staticRenderFns } from "./success_message.vue?vue&type=template&id=2bf6bf16&"
import script from "./success_message.vue?vue&type=script&lang=js&"
export * from "./success_message.vue?vue&type=script&lang=js&"
import style0 from "./success_message.vue?vue&type=style&index=0&id=2bf6bf16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports